import { ModuleBase, Text, HeadingTag, ResponsiveImage } from '@/components';
import { isColorDark } from '@/utils';
import { motion } from 'framer-motion';
import classNames from 'classnames';

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.7, ease: 'easeOut' },
  viewport: { once: true, amount: 0.05 },
};

const IconTextRowModule = ({ data }) => {
  const { headingTitle, description, cards } = data || {};
  const dark = isColorDark(data?.backgroundColour);

  return (
    <ModuleBase data={data}>
      <div className="container flex flex-col items-center px-6 py-10 md:px-10 md:py-14">
        {headingTitle?.heading && (
          <motion.div {...fadeUp} className="w-full">
            <HeadingTag
              data={headingTitle}
              className={classNames(
                'color-from-bg mb-6 max-w-[890px] text-center font-larken font-normal',
                'mx-auto text-[36px] leading-tight sm:text-[44px] lg:text-[52px] xl:text-[64px] xl:leading-[68px]',
              )}
            />
          </motion.div>
        )}

        {description && (
          <motion.div {...fadeUp} className="w-full">
            <Text
              dangerouslySetInnerHTML={{ __html: description }}
              className={classNames(
                'mx-auto mb-14 max-w-[890px] text-center font-gotham text-small-paragraph font-s-light leading-6',
                dark ? 'text-white/75' : 'text-black/75',
              )}
            />
          </motion.div>
        )}

        {cards?.length > 0 && (
          <div className="flex w-full max-w-[1300px] flex-col items-stretch justify-center gap-10 md:flex-row md:flex-wrap md:gap-x-12 md:gap-y-10 lg:gap-x-[60px]">
            {cards.map((card, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: 'easeOut', delay: index * 0.1 }}
                viewport={{ once: true, amount: 0.05 }}
                className="w-full max-w-[420px] flex-1 basis-[220px] text-left md:min-w-[240px]"
              >
                {card.icon && (
                  <div className="mb-2 h-[100px] w-[100px]">
                    <ResponsiveImage image={card.icon} widths={{ xs: 100, md: 100, lg: 100 }} heights={{ xs: null }} />
                  </div>
                )}
                {card.heading && (
                  <p
                    className={classNames(
                      'font-gotham text-[18px] font-n-light leading-6',
                      dark ? 'text-white' : 'text-black',
                    )}
                  >
                    {card.heading}
                  </p>
                )}
                {card.body && (
                  <div
                    className={classNames(
                      'richtext-content mt-2 font-gotham text-small-paragraph font-s-light leading-6 [&_p]:m-0',
                      dark ? 'text-white/75' : 'text-black/75',
                    )}
                    dangerouslySetInnerHTML={{ __html: card.body }}
                  />
                )}
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </ModuleBase>
  );
};

export default IconTextRowModule;
